var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count"},[_c('span',{staticClass:"sum"},[_vm._v(_vm._s(_vm.count))]),_vm._v("Follows")])}
var staticRenderFns = []

export { render, staticRenderFns }